export default "__VITE_ASSET__XVL8Lir6__"